import * as types from './types';

const INITIAL_STATE = {
  loginOffline: false,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.LOGIN_SET_LOGIN_OFFLINE:
      return {
        ...state,
        loginOffline: payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/login/state/login/reducer.js